/**
 * Validate if product is ready for activity options step
 */
export default defineNuxtRouteMiddleware((to) => {
    const { product } = useProduct(to);
    const { firstStepRoute } = useFlow(to);

    if (!product.value.dateFrom) {
        return navigateTo(firstStepRoute.value);
    }
});
